export const woundTypesML1 = {
  //Wound Types
  abrasionOnly: "Abrasion",
  abrasion: "Abrasion/Bruise",
  abscess: "Abscess",
  arterial: "Arterial",
  blister: "Blister",
  bruise: "Bruise",
  burn: "Burn",
  cancerLesion: "Cancer Lesion",
  diabetic: "Diabetic",
  hematoma: "Hematoma",
  hSuppurtiva: "Hidradenitis Suppurativa",
  laceration: "Laceration",
  masd: "Moisture Associated Skin Damage (MASD)",
  mole: "Mole",
  lesion: "Open Lesion",
  pressureUlcer: "Pressure",
  pressureKennedy: "Pressure - Kennedy Terminal Ulcer",
  pressureDeviceRelated: "Pressure - Medical Device Related Pressure Injury",
  rash: "Rash",
  skinTear: "Skin Tear",
  stoma: "Stoma",
  surgical: "Surgical",
  venous: "Venous",
  undiagnosed: "Undiagnosed",

  //Sub Types
  ////Skin Tear
  type1None: "No Skin Loss",
  type2Partial: "Partial Flap Loss",
  type3Total: "Total Flap Loss",
  category1: "Category I: Linear - Linear type (full thickness)",
  category1b: "Category Ib: Flap - Flap type (partial thickness)",
  category2a: "Category IIa: <25% Partial Tissue Loss",
  category2b: "Category IIb: >25% Partial Tissue Loss",
  category3: "Category III: Complete tissue loss",
  category1Linear: "Category I: Linear - Linear type (full thickness)",
  category1Flap: "Category Ib: Flap - Flap type (partial thickness)",
  category2below25: "Category IIa: <25% Partial Tissue Loss",
  category2above25: "Category IIb: >25% Partial Tissue Loss",
  category3complete: "Category III",

  ////Burn
  first: "First Degree",
  second: "Second Degree",
  third: "Third Degree",
  fourth: "Fourth Degree",

  ////Bruise
  bruiseType: "Colour",

  ////// (Bruise) Color
  red: "Red",
  bluePurple: "Blue/Purple",
  green: "Green",
  yellowBrown: "Yellow/Brown",

  ////Pressure Ulcer, Pressure Kennedy, Pressure Device Related
  one: "Stage 1",
  two: "Stage 2",
  three: "Stage 3",
  four: "Stage 4",
  dti: "Deep Tissue Injury",
  unstageable: "Unstageable",

  ////Pressure Ulcer, Pressure Device Related
  mucosalMembrane: "Mucosal Membrane",

  //////(Pressure Ulcer, Pressure Kennedy, Pressure Device Related) Unstageable
  necrosis: "Slough and/or eschar",
  dressing: "Non-removable device/dressing",

  ////MASD
  iad: "IAD",
  other: "Other",

  ////Surgical
  surgicalClosure: "Surgical Closure Method",
  surgicalOther: "Other",

  //////Surgical Closure Method
  closureSutures: "Sutures",
  closureStaples: "Staples",
  closureTape: "Tape",
  closureSteriStrips: "Steri-Strips",
  closureTissueAdhesives: "Tissue Adhesives",
  closureOther: "Other",

  //////(Surgical) Other
  incisionApprox: "Incision Approximated",
  dehiscence: "Dehiscence",
  healingRidge: "Healing Ridge",

  // Diabetic
  gradeZero: "Grade 0",
  gradeOne: "Grade 1",
  gradeTwo: "Grade 2",
  gradeThree: "Grade 3",
  gradeFour: "Grade 4",
  gradeFive: "Grade 5",

  ////Applies to all notSet keys
  notSet: "Not Set"
};
